"use client";

import { withErrorNoteNotification } from "@/lib/error-note-updates";

import type { ProblemDataAdapter } from "@workspace/gamja-platform/components/problem-data-adapter";

import {
  getProblemHistoryById,
  getProblemHistoryBySessionId,
} from "@/lib/server-actions/problem/read";
import {
  saveProblemHistory as saveProblemHistoryAction,
  saveProblemHistoryAnonymous as saveProblemHistoryAnonymousAction,
} from "@/lib/server-actions/problem/write";
import {
  saveErrorNote,
  createErrorNoteItem,
  saveErrorNoteItem,
  deleteErrorNoteItem,
  renameErrorNoteItem,
  reorderErrorNotes,
} from "@/lib/server-actions/problem/errorNotes";
import {
  saveProblemAsSaved,
  saveProblemAsSavedAnonymous,
  unsaveProblemAsSaved,
  unsaveProblemAsSavedAnonymous,
} from "@/lib/server-actions/problem/problemSave";
import { getTotalProblemCount } from "@/lib/server-actions/problem/history";

async function denyAnonymousErrorNote() {
  return { success: false, error: "오답노트는 로그인 후 Premium 이상 이용권으로 사용할 수 있습니다." };
}

/**
 * 공용 ProblemAnswer 에 주입하는 JCG 풀이 데이터 구현.
 *
 * 모듈 상수라 렌더마다 새로 만들지 않는다(Context value 재생성 방지).
 */
export const jcgProblemDataAdapter: ProblemDataAdapter = {
  getProblemHistoryById,
  getProblemHistoryBySessionId,
  saveProblemHistory: (problemId, isCorrect, userAnswer, options) =>
    saveProblemHistoryAction(problemId, isCorrect, userAnswer, { ...options, clientToken: options?.clientToken ?? crypto.randomUUID() }),
  saveProblemHistoryAnonymous: (sessionId, problemId, isCorrect, userAnswer, options) =>
    saveProblemHistoryAnonymousAction(sessionId, problemId, isCorrect, userAnswer, { ...options, clientToken: options?.clientToken ?? crypto.randomUUID() }),
  saveErrorNote: withErrorNoteNotification(saveErrorNote),
  saveErrorNoteAnonymous: denyAnonymousErrorNote,
  createErrorNoteItem: withErrorNoteNotification(createErrorNoteItem),
  createErrorNoteItemAnonymous: denyAnonymousErrorNote,
  saveErrorNoteItem: withErrorNoteNotification(saveErrorNoteItem),
  saveErrorNoteItemAnonymous: denyAnonymousErrorNote,
  deleteErrorNoteItem: withErrorNoteNotification(deleteErrorNoteItem),
  deleteErrorNoteItemAnonymous: denyAnonymousErrorNote,
  renameErrorNoteItem: withErrorNoteNotification(renameErrorNoteItem),
  renameErrorNoteItemAnonymous: denyAnonymousErrorNote,
  reorderErrorNotes: withErrorNoteNotification(reorderErrorNotes),
  reorderErrorNotesAnonymous: denyAnonymousErrorNote,
  saveProblemAsSaved,
  saveProblemAsSavedAnonymous,
  unsaveProblemAsSaved,
  unsaveProblemAsSavedAnonymous,
  getTotalProblemCount,
};
